/**
 * BugAnnotationEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { BugEntity } from "../BugEntity";
import { BugAnnotationEntity } from "../BugAnnotationEntity";
declare global {
    interface EntityTypeMap {
        BugAnnotation: BugAnnotationEntity;
    }
}
export abstract class BugAnnotationGeneratedEntity extends BaseEntity {
    public abstract templateId: string | null;
    public abstract creationDate: Date;
    public abstract hasMetadata: boolean;
    public abstract drawingHint: number;
    public abstract temp: boolean;
    public abstract bugAnnotationId: string;
    public abstract bug: BugEntity;
    public abstract parentAnnotatedEntity: BugEntity;
}
